import { render, staticRenderFns } from "./running.vue?vue&type=template&id=e6874cb2&scoped=true&"
import script from "./running.vue?vue&type=script&lang=js&"
export * from "./running.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6874cb2",
  null
  
)

export default component.exports